module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-app', [_c('v-card', {}, [_c('v-card-title', {
    staticClass: " pt-5"
  }, [_c('div', {}, [_c('v-icon', {
    staticClass: "primary--text pr-2 pb-1",
    staticStyle: {
      "vertical-align": "middle"
    }
  }, [_vm._v("people")]), _vm._v("\n      " + _vm._s(_vm.title) + "\n    ")], 1), _vm._v(" "), _c('v-spacer'), _vm._v(" "), (_vm.search) ? _c('v-text-field', {
    attrs: {
      "append-icon": "search",
      "label": "Search",
      "single-line": "",
      "hide-details": ""
    },
    model: {
      value: (_vm.search_text),
      callback: function($$v) {
        _vm.search_text = $$v
      },
      expression: "search_text"
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('v-data-table', {
    attrs: {
      "headers": _vm.headers,
      "search": _vm.search_text,
      "select-all": _vm.edit,
      "hide-actions": ""
    },
    scopedSlots: _vm._u([
      ["items", function(props) {
        return [(_vm.edit) ? _c('td', [_c('v-checkbox', {
          attrs: {
            "hide-details": "",
            "primary": ""
          },
          model: {
            value: (props.item.value),
            callback: function($$v) {
              props.item.value = $$v
            },
            expression: "props.item.value"
          }
        })], 1) : _vm._e(), _vm._v(" "), _c('td', [_vm._v(_vm._s(props.item.name))]), _vm._v(" "), _c('td', {
          staticClass: "text-xs-right"
        }, [_vm._v(_vm._s(props.item.email))]), _vm._v(" "), _c('td', {
          staticClass: "text-xs-right"
        }, [_vm._v(_vm._s(props.item.mobile))]), _vm._v(" "), _c('td', {
          staticClass: "text-xs-right"
        }, [_vm._v(_vm._s(props.item.city))]), _vm._v(" "), _c('td', {
          staticClass: "text-xs-right"
        }, [_vm._v(_vm._s(props.item.type))]), _vm._v(" "), _c('td', {
          staticClass: "text-xs-right"
        }, [_vm._v(_vm._s(props.item.fee))]), _vm._v(" "), _c('td', {
          staticClass: "text-xs-right"
        }, [_vm._v(_vm._s(props.item.accepted))]), _vm._v(" "), _c('td', {
          staticClass: "text-xs-right"
        }, [_vm._v(_vm._s(props.item.requested))]), _vm._v(" "), _c('td', {
          staticClass: "text-xs-right"
        }, [_vm._v(_vm._s(props.item.status))])]
      }]
    ]),
    model: {
      value: (_vm.items),
      callback: function($$v) {
        _vm.items = $$v
      },
      expression: "items"
    }
  })], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-f0061b16"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Administration.vue
// module id = 126
// module chunks = 1